(() => {
  const root = document.querySelector('[data-gq-collection]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => [...root.querySelectorAll(selector)];
  const labels = JSON.parse($('[data-gq-labels]').textContent);
  const flow = $('#gqs-journey');
  const stage = $('.gqs-product-stage');
  const counter = $('.gqs-journey-position');
  const toolbar = $('.gqs-browse-tools');
  const refinement = $('#gqs-refine');
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const atmosphere = $('.gqs-atmosphere');
  const featured = [
    'bandai-hg-01-gundam-gquuuuuux',
    'hg-04-gms-a-red-gundam-gquuuuuux',
    'hg-08-gms-k-gfred-gquuuuuux',
  ];
  const images = new WeakMap();
  let products = $$('.gqs-product-scene');
  let filtered = [];
  let category = 'All products';
  let savedOnly = false;
  let paused = false;
  let motion = false;
  let frame = 0;
  let active = -1;
  function register(items) {
    for (const item of items) {
      const image = item.querySelector('.gqs-source-image');
      if (image)
        images.set(image, {
          src: image.getAttribute('src'),
          srcset: image.getAttribute('srcset'),
        });
      const button = item.querySelector('.gqs-change-photo');
      if (!button) continue;
      const photos = JSON.parse(
        item.querySelector('[data-product-images]').textContent,
      );
      button.addEventListener('click', () => {
        const index = (Number(button.dataset.photo) + 1) % photos.length;
        button.dataset.photo = String(index);
        image.removeAttribute('srcset');
        image.src = photos[index];
        images.set(image, {src: photos[index], srcset: null});
        button.querySelector('[data-photo-label]').textContent =
          `${labels.photo} ${index + 1} / ${photos.length}`;
      });
    }
  }
  function loadImage(item) {
    const image = item.querySelector('.gqs-source-image');
    const source = images.get(image);
    if (!source || image.hasAttribute('src')) return;
    if (source.srcset) image.setAttribute('srcset', source.srcset);
    image.setAttribute('src', source.src);
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(updatePosition);
  }
  function updatePosition() {
    frame = 0;
    if (!motion || !filtered.length) return;
    const position = Math.max(0, -flow.getBoundingClientRect().top);
    const index = Math.max(
      0,
      Math.min(
        filtered.length - 1,
        Math.floor(
          (position * filtered.length) /
            Math.max(1, flow.offsetHeight - innerHeight),
        ),
      ),
    );
    if (index === active) return;
    active = index;
    counter.textContent = `${labels.product} ${String(index + 1).padStart(2, '0')} ${labels.of} ${filtered.length}`;
    filtered.forEach((item, i) => {
      item.classList.toggle('is-distant', Math.abs(i - index) > 1);
      if (Math.abs(i - index) <= 1) loadImage(item);
    });
  }
  function updateMotion() {
    motion = CSS.supports('animation-timeline: view()') && !preference.matches;
    flow.dataset.motion = motion ? 'true' : 'false';
    counter.hidden = !motion;
    if (!motion)
      products.forEach((item) => {
        item.classList.remove('is-distant');
        loadImage(item);
      });
    if (preference.matches || paused || document.hidden)
      delete atmosphere.dataset.marqueeRunning;
    else atmosphere.dataset.marqueeRunning = 'true';
    for (const button of $$('[data-motion-toggle]')) {
      button.hidden = false;
      button.disabled = preference.matches;
      button.setAttribute('aria-pressed', String(paused || preference.matches));
      const label = preference.matches
        ? labels.off
        : paused
          ? labels.play
          : labels.pause;
      button.setAttribute('aria-label', label);
      button.title = label;
      button.querySelector('[data-motion-icon]').textContent =
        preference.matches || paused ? '▷' : 'Ⅱ';
      const text = button.querySelector('[data-motion-label]');
      if (text)
        text.textContent = preference.matches
          ? labels.off_short
          : paused
            ? labels.play_short
            : labels.pause_short;
    }
    active = -1;
    schedule();
  }
  function align() {
    const target = filtered.length ? flow : $('.gqs-empty');
    scrollTo({
      top:
        scrollY +
        target.getBoundingClientRect().top -
        toolbar.getBoundingClientRect().height,
      behavior: 'instant',
    });
  }
  function saved(item) {
    return (
      item
        .querySelector('[data-shinka-wishlist-toggle]')
        .getAttribute('aria-pressed') === 'true'
    );
  }
  function render(reposition = true) {
    const search = $('[data-search]').value.trim().toLowerCase();
    const stock = $('[data-stock]').value;
    const sort = $('[data-sort]').value;
    filtered = products.filter(
      (item) =>
        (category === 'All products' || item.dataset.category === category) &&
        (stock === 'All availability' || item.dataset.stock === stock) &&
        (!savedOnly || saved(item)) &&
        item.dataset.title.toLowerCase().includes(search),
    );
    filtered.sort((a, b) => {
      if (sort === 'low')
        return Number(a.dataset.price) - Number(b.dataset.price);
      if (sort === 'high')
        return Number(b.dataset.price) - Number(a.dataset.price);
      if (sort === 'name')
        return a.dataset.title.localeCompare(b.dataset.title);
      const ai = featured.indexOf(a.dataset.handle),
        bi = featured.indexOf(b.dataset.handle);
      return (
        (ai < 0 ? 999 : ai) - (bi < 0 ? 999 : bi) ||
        Number(a.dataset.originalOrder) - Number(b.dataset.originalOrder)
      );
    });
    flow.style.setProperty('--scene-count', Math.max(1, filtered.length));
    filtered.forEach((item, i) => {
      item.style.setProperty('--item-index', i);
      item.querySelector('.gqs-product-number').textContent = String(
        i + 1,
      ).padStart(2, '0');
    });
    stage.replaceChildren(counter, ...filtered);
    flow.hidden = !filtered.length;
    $('.gqs-empty').hidden = Boolean(filtered.length);
    $('.gqs-selection-end').hidden = !filtered.length;
    $('[data-empty-title]').textContent = savedOnly
      ? labels.empty_saved
      : labels.no_match;
    $('[data-empty-copy]').textContent = savedOnly
      ? labels.save_hint
      : labels.try_again;
    $('[data-result-count]').textContent =
      `${filtered.length} ${labels.results}`;
    $('[data-clear]').hidden =
      category === 'All products' &&
      !search &&
      stock === 'All availability' &&
      !savedOnly;
    $('[data-saved-count]').textContent = products.filter(saved).length;
    $('[data-total-count]').textContent = products.length;
    for (const button of $$('.gqs-categories [data-category]')) {
      button.querySelector('[data-category-count]').textContent =
        button.dataset.category === 'All products'
          ? products.length
          : products.filter(
              (item) => item.dataset.category === button.dataset.category,
            ).length;
    }
    active = -1;
    schedule();
    if (reposition) align();
  }
  function reset() {
    category = 'All products';
    savedOnly = false;
    $('[data-search]').value = '';
    $('[data-stock]').value = 'All availability';
    $('[data-sort]').value = 'featured';
    $$('[data-category]')
      .filter((e) => e.tagName === 'BUTTON')
      .forEach((button) =>
        button.setAttribute(
          'aria-pressed',
          String(button.dataset.category === category),
        ),
      );
    $('[data-saved-filter]').setAttribute('aria-pressed', 'false');
    render();
  }
  register(products);
  if (CSS.supports('animation-timeline: view()') && !preference.matches) {
    products.slice(2).forEach((item) => {
      const image = item.querySelector('.gqs-source-image');
      if (image) {
        image.removeAttribute('srcset');
        image.removeAttribute('src');
      }
    });
  }
  for (const button of $$('.gqs-categories [data-category]'))
    button.addEventListener('click', () => {
      category = button.dataset.category;
      for (const sibling of $$('.gqs-categories [data-category]'))
        sibling.setAttribute('aria-pressed', String(sibling === button));
      render();
    });
  $('[data-refine]').addEventListener('click', () => {
    refinement.hidden = !refinement.hidden;
    $('[data-refine]').setAttribute(
      'aria-expanded',
      String(!refinement.hidden),
    );
    $('[data-refine]').textContent =
      `${refinement.hidden ? '+' : '−'} ${labels.refine}`;
    if (refinement.hidden) align();
  });
  $('[data-search]').addEventListener('input', () => render());
  $('[data-stock]').addEventListener('change', () => render());
  $('[data-sort]').addEventListener('change', () => render());
  $('[data-saved-filter]').addEventListener('click', () => {
    savedOnly = !savedOnly;
    $('[data-saved-filter]').setAttribute('aria-pressed', String(savedOnly));
    render();
  });
  $$('[data-reset], [data-clear]').forEach((button) =>
    button.addEventListener('click', reset),
  );
  $$('[data-motion-toggle]').forEach((button) =>
    button.addEventListener('click', () => {
      paused = !paused;
      updateMotion();
    }),
  );
  addEventListener('scroll', schedule, {passive: true});
  addEventListener('resize', schedule);
  preference.addEventListener('change', updateMotion);
  document.addEventListener('visibilitychange', updateMotion);
  let savedFrame = 0;
  const savedObserver = new MutationObserver((mutations) => {
    if (
      !mutations.some((m) =>
        m.target.matches('[data-shinka-wishlist-toggle]'),
      ) ||
      savedFrame
    )
      return;
    savedFrame = requestAnimationFrame(() => {
      savedFrame = 0;
      $('[data-saved-count]').textContent = products.filter(saved).length;
      if (savedOnly) render(false);
    });
  });
  savedObserver.observe(root, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-pressed'],
  });
  render(false);
  updateMotion();
  async function bindLateWishlist(items) {
    const config = window.ShinkaWishlistConfig || {};
    const prefix = `${config.proxyPrefix || '/apps/shinka-wishlist'}/wishlist`;
    const identity = {
      email: config.email || '',
      shopifyCustomerId: String(config.shopifyCustomerId || ''),
    };
    let ids = new Set();
    if (identity.email || identity.shopifyCustomerId) {
      try {
        const response = await fetch(
          `${prefix}?${new URLSearchParams(identity)}`,
        );
        if (response.ok)
          ids = new Set(
            ((await response.json()).items || []).map((item) =>
              String(item.variantId),
            ),
          );
      } catch {}
    }
    for (const item of items) {
      const button = item.querySelector('[data-shinka-wishlist-toggle]');
      const variantId = button.dataset.variantId;
      button.setAttribute('aria-pressed', String(ids.has(variantId)));
      button.classList.toggle('is-active', ids.has(variantId));
      button.addEventListener('click', async () => {
        if (!identity.email && !identity.shopifyCustomerId) {
          location.assign(
            `/account/login?return_url=${encodeURIComponent(location.pathname + location.search + location.hash)}`,
          );
          return;
        }
        const wasSaved = button.getAttribute('aria-pressed') === 'true';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        const label = button.querySelector('[data-shinka-wishlist-label]');
        label.textContent = button.dataset.labelLoading;
        try {
          const response = wasSaved
            ? await fetch(
                `${prefix}/items/${encodeURIComponent(variantId)}?${new URLSearchParams(identity)}`,
                {method: 'DELETE'},
              )
            : await fetch(`${prefix}/items`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                  ...identity,
                  shopDomain: config.shopDomain || '',
                  productId: button.dataset.productId,
                  variantId,
                  productHandle: button.dataset.productHandle,
                  sourceSurface: 'collection_page',
                  reminderEnabled: true,
                  autoAddOnRestock: false,
                }),
              });
          if (!response.ok) throw new Error('Wishlist update failed');
          button.setAttribute('aria-pressed', String(!wasSaved));
          button.classList.toggle('is-active', !wasSaved);
          label.textContent = wasSaved
            ? button.dataset.labelAdd
            : button.dataset.labelSaved;
          window.dispatchEvent(
            new CustomEvent('shinka:wishlist:variant-state', {
              detail: {variantId, saved: !wasSaved},
            }),
          );
        } catch {
          label.textContent = button.dataset.labelRetry;
        } finally {
          button.disabled = false;
          button.setAttribute('aria-busy', 'false');
        }
      });
    }
  }
  async function loadRemaining() {
    let next = $('[data-next-page]');
    const visited = new Set();
    while (next) {
      const url = new URL(next.href, location.origin);
      if (url.origin !== location.origin || visited.has(url.href)) break;
      visited.add(url.href);
      const preview = new URL(location.href).searchParams;
      for (const key of ['view', 'preview_theme_id', '_ab', '_fd', '_sc'])
        if (preview.has(key)) url.searchParams.set(key, preview.get(key));
      url.searchParams.set('section_id', root.dataset.sectionId);
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Collection page unavailable');
        const doc = new DOMParser().parseFromString(
          await response.text(),
          'text/html',
        );
        const added = [...doc.querySelectorAll('.gqs-product-scene')].filter(
          (item) =>
            !products.some(
              (existing) => existing.dataset.id === item.dataset.id,
            ),
        );
        if (!added.length) break;
        register(added);
        products.push(...added);
        render(false);
        await bindLateWishlist(added);
        next = doc.querySelector('[data-next-page]');
        $('[data-pagination]').innerHTML = next ? next.outerHTML : '';
        $('[data-pagination]').hidden = true;
      } catch {
        $('[data-pagination]').hidden = false;
        const note = document.createElement('p');
        note.className = 'gqs-loading-note';
        note.textContent = labels.loading_error;
        $('[data-pagination]').prepend(note);
        return;
      }
    }
    $('[data-pagination]').hidden = true;
  }
  loadRemaining();
})();
